// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "dirty": false,
    "raw": "v1.0.4-0-g2bc9a62",
    "hash": "g2bc9a62",
    "distance": 0,
    "tag": "v1.0.4",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.0.4",
        "major": 1,
        "minor": 0,
        "patch": 4,
        "prerelease": [],
        "build": [],
        "version": "1.0.4"
    },
    "suffix": "0-g2bc9a62",
    "semverString": "1.0.4",
    "version": "1.0.4",
    "versionDateTime": "2025-10-06T10:24:28.832Z"
};
